import { inject } from '@angular/core';
import { LocalStorageService } from './../services/local-storage.service';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

export namespace esnAbonneeGuard {

  export const canActivate: CanActivateFn = () => {
    const _localStorageService = inject(LocalStorageService);
    const _router = inject(Router);

    const activeSubscription = _localStorageService.getData('subscription');
    if (!activeSubscription) {
      _router.navigate(['/404']);
      return false;
    } else {
      return true;
    }
  };
  export const canActivateChild: CanActivateChildFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) => canActivate(route, state);
}
